import { render } from "./MonthsTab.vue?vue&type=template&id=d2e2f49a&ts=true"
import script from "./MonthsTab.vue?vue&type=script&lang=ts"
export * from "./MonthsTab.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__